import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setCoachesArray, setGlobalInfo, setLocalInfo, AsyncAllInfos, filterSearch } from '../statistics/statistics.action';

import SearchFilter from '../../components/search-filter/search-filter'
import { Card, Icon, Table } from 'antd';
import TableColumns from '../../../utils/table-coaches-columns';
import moment from 'moment';
import CoachesInfo from './coache-info/coaches-info';

import './coaches.css';
import { STATUS } from '../../../utils/constants';

class Coaches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      changeModal: false,
      index: null
    }

    this.updateData = this.updateData.bind(this)
    this.generateCsv = this.generateCsv.bind(this)
    this.openModal = this.openModal.bind(this)
  }

  openModal(email){
    const index = this.props.statistics.coachesInfoArray.findIndex(el=>el.email === email)
    this.setState({
        index,
        changeModal: true
    })
  }

  componentDidMount() {
    this.props.AsyncAllInfos();
    this.setState({
      dataSource: this.props.statistics.coachesInfoArray
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.statistics.coachesInfoArray) {
      this.setState({ dataSource: nextProps.statistics.coachesInfoArray })
    }
  }

  generateCsv() {
    const arrayInfo = this.state.dataSource.map(a => ({
      ...a,
      last_login: a.last_login ? moment(a.last_login).format('DD/MM/YYYY HH:mm') : '',
      last_session: a.last_session ? moment(a.last_session).format('DD/MM/YYYY HH:mm') : '',
      status: STATUS[a.status]
    }))

    let keys = ['name', 'email', 'total_coachees','site', 'phone', 'phones', 'coupon', 'last_login', 'sessions', 'complete_cycles', 'total_coaching_hours', 'status']
    let array = [['Nome', 'Email', 'Coachees', 'Site', 'Telefone Principal', 'Telefones Adicionais', 'Cupom', 'Último acesso', 'Sessões realizadas', 'Ciclos finalizados', 'Horas coaching', 'Status',]]

    for (let item of arrayInfo) { 
      let arrayAux = []
      for (let key of keys) {
        arrayAux.push(item[key])
      }
      array.push(arrayAux)
    }

    let csv = '';
    array.forEach((row) => {
      csv += row.join(';');
      csv += "\n";
    });

    let hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = 'tabela.csv';
    hiddenElement.click();
  }


  updateData(array = this.props.statistics.coachesInfoArray) {
    this.setState({ dataSource: array })
  }
  render() {
    const paths = [{ icon: 'home' }, { icon: 'line-chart', text: 'Estatísticas' }];
    let { coachesInfoArray, syncronizing, searchInput } = this.props.statistics;

    return (
      <Fragment>

        <div className='statistics-container coaches-container'>
          <section className='stats'>
            <Card title='Coaches Cadastrados' className='table-coach'>
               <div className='coaches-content'>
                  <button className='export-csv' onClick={this.generateCsv} disabled={syncronizing}>
                  <Icon type="download" theme="outlined" />
                  Download CSV</button>
  
                  {!syncronizing &&
                  <SearchFilter onChange={this.props.filterSearch} updateData={this.updateData} dataSource={coachesInfoArray} searchInput={searchInput} className="search-filter" />
                  }
              </div> 
  
              {syncronizing ? <Icon type='sync' spin={syncronizing} className="icon-value" /> :
                <section className='table'>
                  <Table columns={TableColumns} dataSource={this.state.dataSource.map((a,index) => (
                    {
                      ...a,
                      index:{
                        id:index,
                        x:()=>this.openModal(a.email)
                      },
                      last_session: a.last_session ? moment(a.last_session).format('DD/MM/YYYY HH:mm') : '',
                      status: STATUS[a.status]
                    }
                  ))} />
                </section>
  
              }
              <section className='footer'></section>
            </Card>
  
          </section>
          
          <button onClick={() => this.props.AsyncAllInfos(true)} className='refresh-button' title='Atualizar Dados'>
            <Icon type='sync' spin={syncronizing} />
          </button>
        </div>
  
        <CoachesInfo index={this.state.index} isOpen={this.state.changeModal} onClose={() => this.setState({changeModal: false})}/>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  statistics: state.statistics
});

const mapDispatchToProps = dispatch => bindActionCreators({ setCoachesArray, setGlobalInfo, setLocalInfo, AsyncAllInfos, filterSearch }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Coaches);



// WEBPACK FOOTER //
// ./src/App/containers/coaches/coaches.js